import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import store from '../../../store/store';
import { BaseComponent } from '../../base-component/base-component';
import "./my-information-form";

@customElement('mhecomm-my-information-tab')
export class MyInformationTab extends connect(store)(BaseComponent) {
  renderComp() {
    return html`
      <div class="row g-4">
        <div class="col-12">
          <mhecomm-my-information-form></mhecomm-my-information-form>
          <mhecomm-password-validation></mhecomm-password-validation>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-my-information-tab': MyInformationTab;
  }
}
